import { memo } from 'react';
import { Space, Tag } from 'antd';
import { useGetParentSummaryQuery } from '@/services/parent-api';
import { EditSvg } from '@/assets/icons';
import Loading from '@/components/loading';
import { ProfileCol, ProfileRow } from '@/components/profile-grid';
import Button from '@/components/button';

const rangeLabels = {
  interestedIn_0_5: '0-5',
  interestedIn_5_9: '5-9',
  interestedIn_10_12: '10-12',
  interestedIn_13_Plus: '13+',
};

const Family = ({ parentId, permissions }) => {
  const { data } = useGetParentSummaryQuery({ parentId });

  const ageRange = Object.keys(rangeLabels).filter((key) => data?.seeking.ageRange[key]);
  const genders = data?.seeking.gender.values;
  const races = data?.seeking.race.values;

  return data ? (
    <Space direction="vertical" size="small">
      <ProfileRow
        title={
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            Seeking
            {permissions.writeParent && <Button type="link" to="../../edit" icon={<EditSvg fontSize="16" />} />}
          </div>
        }
      >
        <ProfileCol md={12} lg={8} label="Age Ranges of Interest">
          {ageRange.length
            ? ageRange.map((key) => (
                <Tag key={key} color="green">
                  {rangeLabels[key]}
                </Tag>
              ))
            : 'None'}
        </ProfileCol>
        <ProfileCol md={12} lg={8} label="Gender">
          {genders?.length ? genders.map((item) => <Tag key={item.id}>{item.name}</Tag>) : 'None'}
        </ProfileCol>
        <ProfileCol md={12} lg={8} label="Siblings" value={data?.seeking.siblings.name || 'None'} />
        <ProfileCol label="Race/Ethnicity" span={3}>
          {races?.length ? races.map((item) => <Tag key={item.id}>{item.name}</Tag>) : 'None'}
        </ProfileCol>
      </ProfileRow>

      <ProfileRow title="Existing Family" style={{ marginTop: 16 }}>
        <ProfileCol md={12} lg={8} label="Number of Children" value={data?.currentFamily.numberOfChildren || 'None'} />
        <ProfileCol md={12} lg={8} label="Ages" value={data?.currentFamily.ages || 'None'} />
      </ProfileRow>
    </Space>
  ) : (
    <Loading />
  );
};

export default memo(Family);
